import { rolePermissionActionTypes } from './../constants/ApiConstants';
const initialState = {
  master_data: [],
  loading: false,
  get_role_permissions: {},
  role_permission_added: {},
  
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case rolePermissionActionTypes.get_masterdata.REQUEST:
  case rolePermissionActionTypes.get_role_permissions.REQUEST:
  case rolePermissionActionTypes.post_role_permission.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case rolePermissionActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case rolePermissionActionTypes.get_role_permissions.SUCCESS:
    return {
      ...state,
      loading: false,
      get_role_permissions: payload,
    };
  case rolePermissionActionTypes.post_role_permission.SUCCESS:
    return {
      ...state,
      loading: false,
      role_permission_added: payload,

    };
  case rolePermissionActionTypes.post_role_permission.FAILURE:
    return {
      ...state,
      loading: false,
    }; 
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/reducers/RolePermissionReducer.js